const liveViewsTypes = {
    SINGLENARROW: 'singlenarrow',
    SINGLE: 'single',
    SINGLEWIDE: 'singlewide',
    TWOCOLS: 'twocols',
    FULLNARROW: 'fullnarrow',
    FULL: 'full',
    FULLWIDE: 'fullwide'
};

export {
    liveViewsTypes
};
